import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import AmpStepper from '../../components/AmpStepper';
// import AmpBottomNav from '../../components/AmpBottomNav';

const AmpRecents = () => (
  <div>
    <h1>Recents</h1>
    <p>There should be a list of recent tasks displayed here.</p>
    <p>We haven&#39;t built this yet.</p>
  </div>
)

// TODO: encrypt "/amp/stats/:taskId" path for security
// TODO: add auth control before "/amp/stats/:taskId" path can be reached
const AmpModule = () => (
  <div>
    <Switch>
      <Route path="/amp/run" component={AmpStepper} />
      {/* Forward to stats step for given taskId */}
      <Route path="/amp/stats/:taskId" render={({ match }) =>
        <Redirect to={{
            pathname: '/amp/run',
            state: { initialStepIndex: 3, sessionHash: match.params.taskId}
        }}/>
      } />

      <Route path="/amp/recents" component={AmpRecents} />
      <Route exact path="/amp" render={() => <Redirect to="/amp/run" />} />
      <Route exact path="/amp/restart" render={() => <Redirect to="/amp/run" />} />
    </Switch>
    {/*<AmpBottomNav />*/}
  </div>
);

export default AmpModule;



// WEBPACK FOOTER //
// ./src/containers/AmpModule/index.jsx